import {BASE_CLASS as PAGE_BASE_CLASS} from '../../../config.js'

export const BASE_CLASS = `${PAGE_BASE_CLASS}-renting`
